import axios from 'axios';
import useAuthStore from '../store/authStore';

const axiosClient = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
    'Bypass-Tunnel-Reminder': 'true',
    'ngrok-skip-browser-warning': 'true'
  },
  withCredentials: true // Luôn gửi HttpOnly cookie trong các request
});

// Interceptor cho Request
axiosClient.interceptors.request.use(
  (config) => {
    // Lấy token từ Zustand Store thay vì localStorage thuần
    const token = useAuthStore.getState().token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor cho Response
axiosClient.interceptors.response.use(
  (response) => {
    // Backend trả về chuẩn Response<T> (Success, Message, Data)
    return response.data;
  },
  (error) => {
    // Tự động xử lý khi hết hạn phiên đăng nhập (401 Unauthorized)
    if (error.response?.status === 401) {
      useAuthStore.getState().logout();
      if (typeof window !== 'undefined' && window.location.pathname !== '/auth' && window.location.pathname !== '/') {
        window.location.href = '/auth';
      }
    }

    // Bắt lỗi ProblemDetails hoặc lỗi do Response<T>.Failure
    const message = error.response?.data?.message || error.response?.data?.detail || 'Có lỗi xảy ra, vui lòng thử lại';
    return Promise.reject(new Error(message));
  }
);

export default axiosClient;
